module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "max-width": "600px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Influencer Payout Verification")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ims-modal-body"
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Submitted By: ")]), _vm._v(" "), _c('p', [(_vm.payoutData.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.payoutData.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.payoutData.handle) + "\n                  ")]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.payoutData.handle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.payoutData.handle) + "\n                  ")], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("For Campaign: ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.payoutData.campaignName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Submitted Date:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.payoutData.createdAt)))])]), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("To Make Payment:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.payoutData.toMakePaymentAt)) + " (" + _vm._s(_vm.calDaysLeft(_vm.payoutData.toMakePaymentAt)) + ")")])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Engagement Rate")]), _vm._v(" "), _c('p', [_vm._v(_vm._s((_vm.influencerData.engagementRate * 100).toFixed(2)) + " %")])]) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.payoutData.platform === 'tiktok') ? _c('label', [_vm._v("TikTok Followers")]) : _c('label', [_vm._v("Instagram Followers")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.followers))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Receiving Bank A/C No:")]), _vm._v(" "), _c('small', [_vm._v("(omit dashes)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.bankAccount))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Receiving A/C Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.fullName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Bank")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.bankName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Mailing Address")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.mailingAddress))])]), _vm._v(" "), (!_vm.showRequiredActions()) ? _c('v-flex', {
    staticClass: "mb-2 grey lighten-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [(_vm.moneyoutData.bankSwiftCode) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Bank Swift Code")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.bankSwiftCode ? _vm.moneyoutData.bankSwiftCode : '-'))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.BIBREF) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("BIB REF")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.BIBREF))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.FTREF) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("FT REF")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.FTREF))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.REF) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("REF")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.REF))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.billingContact) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("Billing Contact")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.billingContact))])])]) : _vm._e(), _vm._v(" "), (_vm.submissionData.payoutAmount) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("Payout Amount")]), _vm._v(" "), _c('p', [_vm._v("$ "), _c('b', [_vm._v(_vm._s(_vm.submissionData.payoutAmount))])])]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("How would you rate your overall experience with the client?")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "background-color": "grey",
      "color": "secondary",
      "size": "30",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.payoutData.satisfaction_level_on_advertiser),
      callback: function($$v) {
        _vm.$set(_vm.payoutData, "satisfaction_level_on_advertiser", $$v)
      },
      expression: "payoutData.satisfaction_level_on_advertiser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("How would you rate your overall experience with Kobe?")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "background-color": "grey",
      "color": "secondary",
      "size": "30",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.payoutData.satisfaction_level_on_kobe),
      callback: function($$v) {
        _vm.$set(_vm.payoutData, "satisfaction_level_on_kobe", $$v)
      },
      expression: "payoutData.satisfaction_level_on_kobe"
    }
  })], 1), _vm._v(" "), (_vm.payoutData.collaboration) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What do you like about this collaboration?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.collaboration)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.payoutData.improved) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What are areas of improvement about this product/service that will be valuable feedback for them?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.improved)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.payoutData.promotingProducts) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What do you like most about this product/service you are promoting?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.promotingProducts)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.payoutData.audienceEnjoyment) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What do you think your audience enjoyed about your content?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.audienceEnjoyment)
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('small')], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69737920"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PayoutVerificationModal.vue
// module id = 2171
// module chunks = 0